"use client";

import { useActionState } from "react";
import type { FormState } from "./actions";

/*
 * Shared form shell. Uses useActionState so a validation error re-renders in
 * place with the fields intact -- a failed sign-up that clears the form is the
 * quickest way to lose someone at registration.
 */
export function AuthForm({
  action, submit, children, busyLabel = "Working…",
}: {
  action: (prev: FormState, form: FormData) => Promise<FormState>;
  submit: string;
  children: React.ReactNode;
  busyLabel?: string;
}) {
  const [state, formAction, pending] = useActionState(action, {});

  return (
    <form action={formAction} noValidate>
      {children}

      {state.error && (
        <p
          role="alert"
          style={{
            fontSize: 13, marginTop: 14, marginBottom: 0,
            padding: "8px 10px",
            color: "var(--color-danger-900)",
            background: "var(--color-danger-100)",
            border: "1px solid var(--color-danger-500)",
          }}
        >
          {state.error}
        </p>
      )}

      <button className="btn btn-primary btn-block" type="submit" disabled={pending}
              style={{ marginTop: 18 }}>
        {pending ? busyLabel : submit}
      </button>
    </form>
  );
}

export function Field({
  label, name, type = "text", autoComplete, required, placeholder, hint,
}: {
  label: string; name: string; type?: string; autoComplete?: string;
  required?: boolean; placeholder?: string; hint?: string;
}) {
  return (
    <div className="field" style={{ marginBottom: 14 }}>
      <label htmlFor={name}>{label}</label>
      <input
        className="input" id={name} name={name} type={type}
        autoComplete={autoComplete} required={required} placeholder={placeholder}
      />
      {hint && <p className="text-muted" style={{ fontSize: 12, margin: "5px 0 0" }}>{hint}</p>}
    </div>
  );
}
